/** This file contains global functions */

export const readLanguageFromCookie = () => {
    const cookies = document.cookie;
    const cookiearray = cookies.split(";");

    let language = "en";

    for (let i = 0; i < cookiearray.length; i++) {
        const name = cookiearray[i].split("=")[0];
        const value = cookiearray[i].split("=")[1];
        if (name.trim() === "Language" && /^[a-zA-Z]*$/.test(value)) {
            language = value;
        }
    }

    return language;
};
